import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { ThemeProvider } from "next-themes";
import { schliesse_anmeldung_ab } from "./lib/auth";
import { router } from "./router";
import "./styles.css";

/**
 * Kein Echtzeitkanal — die Oberfläche aktualisiert über TanStack Query.
 */
const abfragen = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: true,
      retry: 1,
    },
  },
});

const wurzel = document.getElementById("wurzel");
if (!wurzel) throw new Error("Das Wurzelelement fehlt in index.html.");

async function starte() {
  if (globalThis.location.pathname === "/anmeldung/zurueck") {
    try {
      const ziel = await schliesse_anmeldung_ab();
      globalThis.history.replaceState(null, "", ziel);
    } catch (fehler) {
      console.error("[anmeldung]", fehler);
      globalThis.history.replaceState(
        null,
        "",
        "/anmeldung?fehler=rueckweg",
      );
    }
  }

  createRoot(wurzel!).render(
    <StrictMode>
      <ThemeProvider attribute="class" defaultTheme="system" enableSystem>
        <QueryClientProvider client={abfragen}>
          <RouterProvider router={router} />
        </QueryClientProvider>
      </ThemeProvider>
    </StrictMode>,
  );
}

void starte();
